// Build-time feature flags. Default OFF when the env var is absent so unfinished
// features (e.g. the draft legal pages) can never be published unintentionally.
// Legal pages, site footer and registration TOS-consent are gated behind this flag
// and remain inactive/inaccessible unless REACT_APP_LEGAL_ENABLED is explicitly "true".
export const LEGAL_ENABLED =
  String(process.env.REACT_APP_LEGAL_ENABLED).toLowerCase() === "true";

// Gates the PUBLIC Safety Center link in the homepage footer. The /safety route
// itself is always reachable by direct URL (for Preview review), but it stays
// unlinked/unpublished until this flag is explicitly set to "true".
export const SAFETY_ENABLED =
  String(process.env.REACT_APP_SAFETY_ENABLED).toLowerCase() === "true";
